export const inputPricingOptions = {
  paymentTermUnitOptions: [
    {
      text: 'Day',
      value: 'day'
    },
    {
      text: 'Business Day',
      value: 'working_day'
    }
  ],
  repaymentMethodOptions: [
    {
      text: 'Flat Amount',
      value: 'flat_amount'
    },
    {
      text: 'Percentage',
      value: 'percentage'
    },
    {
      text: 'Total Billing Cycle',
      value: 'total_billing_cycle'
    }
  ],
  repaymentInterestMethodOptions: [
    {
      text: 'Including Interest',
      value: 'include'
    },
    {
      text: 'Separating Interest',
      value: 'exclude'
    }
  ],
  billingUnitOptions: [
    {
      text: 'Day',
      value: 'day'
    },
    {
      text: 'Business Day',
      value: 'working_day'
    },
    {
      text: 'Month',
      value: 'month'
    }
  ]
}

export const validationLimits = {
  billingCycleDurationDays: [1, 90],
  billingCycleDurationMonths: [1, 3],
  billingCycleStartDayMonths: [1, 28],
  paymentTermDuration: [1, 28]
}

export function getDefaultPricing() {
  return {
    id: '',
    pricingAnnualOverdueInterestRate: 0,
    pricingAnnualInterestRate: 0,
    pricingAnnualWithdrawalInterestRate: 0,
    billingCycleUnit: 'day',
    billingCycleDuration: 1,
    billingCycleStartDay: 1,
    paymentTermUnit: 'day',
    paymentTermDuration: 1,
    repaymentMethod: 'flat_amount',
    repaymentInterestMethod: 'include',
    repaymentMinimumFlatAmount: 0,
    repaymentMinimumPercentage: 0
  }
}
